var videoListTag = document.createElement('script');
videoListTag.src = "https://www.youtube.com/iframe_api";
var videoListScriptTag = document.getElementsByTagName('script')[0];
videoListScriptTag.parentNode.insertBefore(videoListTag, videoListScriptTag);

const breakpointVideoList = window.matchMedia('(max-width: 768px)');
const videoItems = document.querySelectorAll('.video-list__item');
const currentVideoContainer = document.getElementById('js-video-list__video-container');
const currentTitle = document.querySelector('.js-video-list__current-title');
const currentVideoThumb = document.querySelector('.js-video-list__current-image');
const currentVideoPlayer = document.getElementById('js-video-list__video-player');
const currentVideoSource = document.getElementById('js-video-list__video-source');
const currentPlayButton = document.querySelector('.js-video-list__current-play');
const currentSoundButton = document.querySelector('.js-video-list__sound');

let videoListPlayer;
let isPlaying = false;
let isMuted = false;

if(videoItems.length && !breakpointVideoList.matches) videoItemsCarousel();

function onYouTubeIframeAPIReady() {
  const firstVideo = videoItems[0];

  if(firstVideo && !firstVideo.classList.contains('video-list__item--video-internal')){
    videoListPlayer = new YT.Player('js-video-list__video-main', {
      height: '100%',
      width: '100%',
      videoId: firstVideo.dataset.videoItemId,
      playerVars: { autoplay:0, controls:0, loop:1, rel:0, playlist:firstVideo.dataset.videoItemId },
      events: { 'onReady': () => { /* no autoplay */ } }
    });
  }

  initVideoThumbnails();

  currentVideoThumb.addEventListener('click', () => {
    playVideo(firstVideo);
    currentVideoPlayer.play().catch(() => console.log('User interaction required'));
    currentVideoThumb.style.display = 'none';
    currentPlayButton.classList.add('playing');
    isPlaying = true;
  });
}

function initVideoThumbnails() {
  videoItems.forEach(videoItem => {
    videoItem.addEventListener('click', () => playVideo(videoItem));
  });
}

function playVideo(videoItem){
  if(!videoItem) return;

  const isInternal = videoItem.classList.contains('video-list__item--video-internal');
  const videoUrl = breakpointVideoList.matches ? videoItem.dataset.videoItemUrlMobile : videoItem.dataset.videoItemUrl;

  currentTitle.innerHTML = videoItem.dataset.videoItemTitle;

  const videoPlayerYT = document.getElementById('js-video-list__video-main');

  if(isInternal){
    videoPlayerYT.style.display = 'none';
    currentVideoPlayer.style.display = 'block';
    currentVideoPlayer.src = videoUrl;
    currentVideoPlayer.load();

    currentVideoThumb.style.display = 'none';
    resetVideoState();

    currentVideoPlayer.play().catch(()=>{ 
      console.log('User interaction needed to play video'); 
      currentVideoThumb.style.display = 'block';
    });

    if(videoListPlayer && typeof videoListPlayer.pauseVideo === 'function') videoListPlayer.pauseVideo();
  } else if(videoListPlayer && typeof videoListPlayer.loadVideoById === 'function'){
    currentVideoPlayer.style.display = 'none';
    videoPlayerYT.style.display = 'block';
    videoListPlayer.loadVideoById(videoItem.dataset.videoItemId);
  }

  videoItems.forEach(item => item.classList.remove('video-list__item--active'));
  videoItem.classList.add('video-list__item--active');
}

currentPlayButton.addEventListener('click', () => {
  if(currentVideoPlayer.style.display === 'block'){
    if(isPlaying){
      currentVideoPlayer.pause();
      isPlaying = false;
      currentPlayButton.classList.remove('playing');
    } else {
      currentVideoThumb.style.display = 'none';
      currentVideoPlayer.play().catch(() => console.log('User interaction required'));
      isPlaying = true;
      currentPlayButton.classList.add('playing');
    }
  } else if(videoListPlayer && typeof videoListPlayer.playVideo === 'function'){
    videoListPlayer.playVideo();
  }
});

currentVideoPlayer.addEventListener('ended', () => {
  currentVideoThumb.style.display = 'block';
  isPlaying = false;
  currentPlayButton.classList.remove('playing');
});

function loadInternalVideo(src){
  currentVideoSource.src = src;
  currentVideoPlayer.load();
}

function resetVideoState(){
  currentVideoPlayer.pause();
  isPlaying = false;
  isMuted = false;
  currentPlayButton.classList.remove('playing');
  currentSoundButton.classList.remove('muted');
}

currentSoundButton.addEventListener('click', () => {
  if(currentVideoPlayer.style.display === 'block'){
    if(isMuted){
      currentVideoPlayer.muted = false;
      isMuted = false;
      currentSoundButton.classList.remove('muted');
    } else {
      currentVideoPlayer.muted = true;
      isMuted = true;
      currentSoundButton.classList.add('muted');
    }
  }
});

currentVideoPlayer.addEventListener('ended', () => {
  currentVideoThumb.style.display = 'block';
  isPlaying = false;
  currentPlayButton.classList.remove('playing');
});

function updateProgress(){
  const currentTimeEl = document.querySelector('.video-list__current-time');
  const currentDurationEl = document.querySelector('.video-list__current-duration');
  const progressEl = document.querySelector('.video-list__progress');

  requestAnimationFrame(updateProgress);

  let currentTime = 0, duration = 1;

  if(currentVideoPlayer.style.display === 'block'){
    currentTime = currentVideoPlayer.currentTime || 0;
    duration = currentVideoPlayer.duration || 1;

    if(currentVideoPlayer.ended){
      const nextVideo = document.querySelector('.video-list__item--active + .video-list__item');
      if(nextVideo) playVideo(nextVideo);
    }
  } else if(videoListPlayer && typeof videoListPlayer.getCurrentTime === 'function'){
    currentTime = videoListPlayer.getCurrentTime() || 0;
    duration = videoListPlayer.getDuration() || 1;
  }

  progressEl.style.width = ((currentTime / duration) * 100) + '%';
  currentTimeEl.innerHTML = formatVideoTime(currentTime);
  currentDurationEl.innerHTML = formatVideoTime(duration);
}

updateProgress();

function videoItemsCarousel(){
  new Swiper('#js-video-list__swiper', {
    spaceBetween:0,
    slidesPerView:5,
    navigation: { nextEl:'.video-list__button-next', prevEl:'.video-list__button-prev' },
  });
}

function formatVideoTime(time){
  time = Math.floor(time);
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? '0'+seconds : seconds}`;
}
